import { Theme } from '@mui/material';

export const MuiToggleButtonStyled = (theme: Theme) => {
    theme.components = {
        ...theme.components,
        MuiToggleButtonGroup: {
            styleOverrides: {
                root: {
                    //base color for icon
                    borderRadius: '5px',
                    '& .MuiToggleButtonGroup-grouped:not(:last-of-type)': {
                        borderRadius: '5px',
                    },
                    '& .MuiToggleButtonGroup-grouped:not(:first-of-type)': {
                        borderLeft: '1px solid',
                        borderRadius: '5px',
                    },
                },
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    marginRight: '15px',
                    color: theme.palette.primary.main,
                    borderColor: theme.palette.primary.main,
                    '&.Mui-selected': {
                        backgroundColor: theme.palette.primary.main,
                        color: '#fff',
                        fontWeight: 700,
                        textDecoration: 'underline',
                        '&:hover': {
                            backgroundColor: '#5D0044',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '5px',
                            fontWeight: 700,
                            textDecoration: 'none',
                        },
                    },
                    '&:hover': {
                        backgroundColor: '#5D0044',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '5px',
                        fontWeight: 700,
                    },
                },
            },
        },
    };
};
